<template>
  <v-data-table :headers="presentationUnityHeaders" :items="presentationUnities" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-row align="center">
          <v-col class="text-subtitle-2 gray--text text--lighten-1">
            Unidades de apresentação
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                  Nova unidade de apresentação
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="editedItem.name"
                          label="Nome"
                          :hide-details="!errors.editedItem"
                          :error-messages="errors.editedItem"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há dados cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "PresentationUnityTable",
    props: {
      presentation: Object,
      refreshList: Function,
    },
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        presentationUnityHeaders: [
          { text: "Nome", value: "name" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
      };
    },
    computed: {
      presentationUnities() {
        return this.presentation.presentationUnities;
      },
      formTitle() {
        return this.editedIndex === -1
          ? "Nova unidade de apresentação"
          : "Editar unidade de apresentação";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.presentationUnities.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medicine/delete_presentation_unity.gql"),
            variables: {
              presentationUnityId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/medicine/save_presentation_unity.gql"),
          variables: {
            presentationId: this.presentation.id,
            presentationUnityId: this.lodash.get(this.editedItem, "id", ""),
            name: this.editedItem.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.editedItem.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
